export default __webpack_public_path__ + "static/media/Monger-HUD-03.77ffcea6.jpg";